import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { JwtHelperService } from "@auth0/angular-jwt";
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { UserRoles } from '../../app.enums';
import { AuthService } from '../../Services/auth.service';
@Injectable()
export class PlanGuard implements CanActivate {
    constructor(private router: Router,
        private jwtHelper: JwtHelperService,
        private authService: AuthService) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        var allowedRoles: UserRoles[] = route.data['allowedRoles'] as UserRoles[];
        return this.hasAccess(state.url, allowedRoles);
    }

    private hasAccess(url: string, allowedRoles: UserRoles[]): Observable<boolean> {
        let isAuthenticated: boolean = this.authService.isAuthenticated();

        if (isAuthenticated) {
            const isFreePlaner = this.authService.isFreePlanUser();
            if (isFreePlaner == true) {
                if (this.authService.isGallery()) {
                    this.router.navigate(['/dashboard']);
                }
                return of(false);
            }
            return of(true);
        }
        return of(false);
    }
}
